// Target Interface
export default class TargetOrder {
  constructor(data, errors = [], needRestaurantId = false, needCheckAddress = false) {
    this.data = data;
    this.errors = errors;
    this.needRestaurantId = needRestaurantId;
    this.needCheckAddress = needCheckAddress;
  }

  getFormattedData() {
    return this.data;
  }

  getErrors() {
    return this.errors;
  }

  getNeedRestaurantId() {
    return this.needRestaurantId;
  }

  getNeedCheckAddress() {
    return this.needCheckAddress;
  }
}
